import { produce } from "immer";
import {
  ADD_GATE,
  ADD_GATE_FAILURE,
  ADD_GATE_SUCCESS,
  //
  DELETE_GATE,
  DELETE_GATE_FAILURE,
  DELETE_GATE_SUCCESS,
  //
  EDIT_GATE,
  EDIT_GATE_FAILURE,
  EDIT_GATE_SUCCESS,
  //
  FETCH_GATES,
  FETCH_GATES_FAILURE,
  FETCH_GATES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  GET_BOOK_INFO,
  GET_BOOK_INFO_FAILURE,
  GET_BOOK_INFO_SUCCESS,
  //
  TOGGLE_INVITE_VISITOR,
  INVITE_VISITOR,
  INVITE_VISITOR_SUCCESS,
  INVITE_VISITOR_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingGates: false,
  gates: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentGate: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  // Book Info
  isFetchingBookInfo: false,
  bookInfo: {},
  inviteVisitorModal: {
    open: false,
  },
  // Invite Visitor
  isInvitingVisitor: false,
};

const VisitorGateReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_GATES:
        draft.isFetchingGates = true;
        draft.gates = [];
        break;
      case FETCH_GATES_SUCCESS:
        draft.isFetchingGates = false;
        draft.gates = action.payload;
        break;
      case FETCH_GATES_FAILURE:
        draft.isFetchingGates = false;
        draft.gates = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentGate = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentGate = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentGate = {};
        break;
      // Add
      case ADD_GATE:
        draft.isSubmitting = true;
        break;
      case ADD_GATE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_GATE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_GATE:
        draft.isSubmitting = true;
        break;
      case EDIT_GATE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_GATE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_GATE:
        draft.isDeleting = true;
        break;
      case DELETE_GATE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_GATE_FAILURE:
        draft.isDeleting = false;
        break;
      // Book Info
      case GET_BOOK_INFO:
        draft.isFetchingBookInfo = true;
        draft.bookInfo = {};
        break;
      case GET_BOOK_INFO_SUCCESS:
        draft.isFetchingBookInfo = false;
        draft.bookInfo = action.payload;
        break;
      case GET_BOOK_INFO_FAILURE:
        draft.isFetchingBookInfo = false;
        draft.bookInfo = {};
        break;
      case TOGGLE_INVITE_VISITOR:
        draft.inviteVisitorModal = action.payload;
        break;
      case INVITE_VISITOR:
        draft.isInvitingVisitor = true;
        break;
      case INVITE_VISITOR_SUCCESS:
        draft.isInvitingVisitor = false;
        break;
      case INVITE_VISITOR_FAILURE:
        draft.isInvitingVisitor = false;
        break;
      default:
        return state;
    }
  });

export default VisitorGateReducer;
